import React, { useEffect } from 'react';
import './DailyHowToPlayModal.css';

const LETTER_COLOR_EXAMPLES = [
  {
    label: 'Green',
    description: 'B is in the word and in the correct spot.',
    letters: ['B', 'R', 'E', 'A', 'K'],
    highlightedIndex: 0,
    tone: 'correct',
  },
  {
    label: 'Yellow',
    description: 'R is in the word but in a different spot.',
    letters: ['D', 'R', 'E', 'A', 'M'],
    highlightedIndex: 1,
    tone: 'present',
  },
  {
    label: 'Gray',
    description: 'C is not in the word in any spot.',
    letters: ['T', 'W', 'I', 'C', 'E'],
    highlightedIndex: 3,
    tone: 'absent',
  },
];

const DailyHowToPlayModal = ({ onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="modal-overlay daily-how-to-overlay" onClick={() => onClose?.()}>
      <div
        className="modal-content daily-how-to-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="daily-how-to-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="daily-how-to-modal__header">
          <h2 id="daily-how-to-title">How To Play</h2>
          <button
            type="button"
            className="daily-how-to-modal__close"
            onClick={() => onClose?.()}
            aria-label="Close How To Play"
          >
            ×
          </button>
        </div>

        <p className="daily-how-to-modal__intro">
          Guess the secret 5-letter word in 6 tries. Use the image and riddle as clues, or ignore
          them and use the tile colors to guide your next guess.
        </p>

        <ul className="daily-how-to-modal__list">
          <li>Each guess must be a valid 5-letter word.</li>
          <li>After every guess, the image zooms out one step.</li>
          <li>By your 5th guess, the image is fully zoomed out.</li>
          <li>Tile colors show how close your guess is.</li>
        </ul>

        <h3>Letter colors</h3>
        <p className="daily-how-to-modal__subcopy">After you submit a guess:</p>

        <div className="daily-how-to-modal__examples">
          {LETTER_COLOR_EXAMPLES.map((example) => (
            <div key={example.label} className="daily-how-to-modal__example-block">
              <div className="daily-how-to-modal__example-row" aria-hidden="true">
                {example.letters.map((letter, index) => (
                  <span
                    key={`${example.label}-${letter}-${index}`}
                    className={[
                      'daily-how-to-modal__cell',
                      index === example.highlightedIndex
                        ? `daily-how-to-modal__cell--${example.tone}`
                        : '',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    {letter}
                  </span>
                ))}
              </div>
              <p className="daily-how-to-modal__example-copy">
                <strong>{example.label}</strong> - {example.description}
              </p>
            </div>
          ))}
        </div>

        <h3>Tips (optional)</h3>
        <ul className="daily-how-to-modal__list">
          <li>Do not overthink the image early, the letters often give faster progress.</li>
          <li>Stuck? Use a guess to test common letters and narrow it down.</li>
        </ul>
      </div>
    </div>
  );
};

export default DailyHowToPlayModal;
